// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__q9U0J","linkBack":"styles_linkBack__ADKpF","linkBackIcon":"styles_linkBackIcon__7rdlp","header":"styles_header__CmCDQ","body":"styles_body__21uGb"};